export const GREAT_MOOD = 'Great!'
export const JUST_OK_MOOD = 'Just OK'
export const BAD_MOOD = 'Bad'
